import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';

export const StockScreenGridId = 'StockScreen.rootDataGrid';
const StockScreenGridOptions: iDataGridDisplayOptions = {
    id: StockScreenGridId,
    columnAutoWidth: false,
    showBorders: false,
    // @ts-ignore
    dimensionsOptions: {
        disableDynamicDimension: true,
    },
    selection: { showCheckBoxesMode: 'none', mode: 'multiple' },
    columnHidingEnabled: false,
    allowColumnReordering: false,
    allowColumnResizing: true,
    //
    filterRow: {
        visible: true,
    },
    masterDetail: {
        enabled: true,
        template: 'GridDetails',
    },
    paging: {
        pageSize: 25,
    },
    pager: {
        visible: true,
        displayMode: 'full',
        showPageSizeSelector: true,
        showInfo: true,
    },
    //
    columns: [
        {
            dataField: 'id',
            caption: 't~StockScreen:column.id',
            dataType: 'string',
        },
        {
            dataField: 'productName',
            caption: 't~StockScreen:column.productName',
            dataType: 'string',
            width: '20%',
        },
        {
            dataField: 'totalAvailableProductUnitsSum',
            caption: 't~StockScreen:column.totalAvailableProductUnitsSum',
            dataType: 'number',
        },
        {
            dataField: 'totalLockedProductUnitsSum',
            caption: 't~StockScreen:column.totalLockedProductUnitsSum',
            dataType: 'number',
        },
    ],
};

propsStore.insert(StockScreenGridOptions);

const masterDetailsGridDetails: iDataGridDisplayOptions = {
    id: `${StockScreenGridId}.masterDetails.GridDetails`,
    dataSourceItemsSelector: 'flatAttributes',
    columnAutoWidth: false,
    grouping: {},
    // @ts-ignore
    dimensionsOptions: {
        disableDynamicDimension: true,
    },
    groupPanel: {
        visible: false,
    },
    columns: [
        {
            caption: 't~StockScreen:column.attributeName',
            dataField: 'attributeName',
            groupIndex: 0,
            allowFiltering: false,
        },
        {
            caption: 't~StockScreen:column.attributeValue',
            dataField: 'attributeValue',
            dataType: 'string',
            width: '20%',
            allowFiltering: false,
        },
        {
            caption: 't~StockScreen:column.warehouseStock',
            dataField: 'warehouseStock',
            cellTemplate: 'GridColumn',
            allowFiltering: false,
        },
    ],
};
propsStore.insert(masterDetailsGridDetails);

propsStore.insert({
    id: `${StockScreenGridId}.masterDetails.GridDetails.column.warehouseStock`,
    $schema: 'http://myserver/DataGridSchema.json',
    dimensionsOptions: {
        disableDynamicDimension: true,
    },
    columns: [
        {
            caption: 't~StockScreen:column.warehouseName',
            dataField: 'warehouseName',
        },
        {
            caption: 't~StockScreen:column.availableUnits',
            dataField: 'availableUnits',
        },
        {
            caption: 't~StockScreen:column.lockedUnits',
            dataField: 'lockedUnits',
        },
    ],
} as iDataGridDisplayOptions);
